import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { updateUiAction } from 'actions/uiActions'
import { batchUpdateCalculatorAction } from 'actions/calculatorActions'
import { updateEntityAction } from 'actions/entityActions'
import { currentDeviceSelector } from 'selectors/components'

function mapStateToProps(state) {
  const { id, location: { lat, lng } } = currentDeviceSelector(state)

  return {
    map: state.map.ref,
    type: state.currentEntity.type,
    id,
    lat,
    lng
  }
}

const bounds = { lat: { min: -90, max: 90 }, lng: { min: -180, max: 180 } }

class EditLocation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lat: this.props.lat,
      lng: this.props.lng,
      latError: null,
      lngError: null
    }
  }

  onSubmitCallback = _ => {
    const { state: { lat, lng, latError, lngError }, props: { id, map, type,
      batchUpdateCalculatorAction, updateEntityAction, updateUiAction } } = this
    if (latError || lngError) return

    if (type === 'camera') batchUpdateCalculatorAction({ location: { lat, lng } }, ['location'], id, true)
    else updateEntityAction(type + 's', id, { location: { lat, lng } })

    updateUiAction({ modal: null })
    map.panTo({ lat, lng })
  }

  handleChange = ({ target: { name, value } }) => {
    if ((value === undefined) || (value.length === 0) || !value.trim() || isNaN(parseFloat(value))) {
      return this.setState({ [`${name}Error`]: 'Invalid number' })
    }

    const newValue = parseFloat(value)
    if (newValue < bounds[name].min || newValue > bounds[name].max) {
      return this.setState({ [`${name}Error`]: `Must be between ${bounds[name].min} and ${bounds[name].max}` })
    }

    this.setState({ [`${name}Error`]: null, [name]: newValue })
  }

  render() {
    const { state: { lat, lng, latError, lngError }, onSubmitCallback, handleChange, props: { close, classes } } = this

    return (
      <div>
        <label className={classes.label}>Position by latitude and longitude:</label>
        <div className={classes.latLngContainer}>
          <input
            defaultValue={lat}
            name='lat'
            onChange={handleChange}
            type='text'
            className={classes.latlng + (latError ? ' invalid' : '')}
          />
          <input
            defaultValue={lng}
            name='lng'
            onChange={handleChange}
            type='text'
            className={classes.latlng + (lngError ? ' invalid' : '')}
          />
        </div>
        <div className={classes.errorText}>
          <span className={latError ? classes.errorTextFadeIn : classes.errorTextFadeOut}>{latError}</span>
          <span className={lngError ? classes.errorTextFadeIn : classes.errorTextFadeOut}>{lngError}</span>
        </div>
        <div className={classes.buttons}>
          <div className={classes.buttonContainer}>
            <button
              className={classes.saveButton + ((latError || lngError) ? ' disabled' : '')}
              onClick={onSubmitCallback.bind(this)}
            >
              Save
            </button>
            <button
              className={classes.cancelButton}
              onClick={close}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export const EditLocationConfig = {}
export default connect(mapStateToProps, { updateUiAction, batchUpdateCalculatorAction, updateEntityAction })(
  injectSheet(style)(EditLocation)
)



// WEBPACK FOOTER //
// ./src/components/EditLocation/index.js